import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserObject } from "../../../../../utils/getUserObject";
import { getPartRequestMessages } from "../../../reduxStore/entities/messages";
import SendMessageForm from "./SendMessageForm";
import { getCreatedAtString } from "../../../utils/helpers/getCreatedAtString";

const ChatSidebar = ({ partOfferStatus, partOfferId, conversationUserIds, partOfferCreatedAt }) => {
    const dispatch = useDispatch();
    const messageContainerRef = useRef(null);
    const [showInfoBox, setShowInfoBox] = useState(true);


    const [loaded, setLoaded] = useState(false);

    const fetchedMessages = useSelector(
        (state) => state.messages.partRequestMessages || []
    );


    const filterDto = {
        partOfferId: partOfferId,
    };

    useEffect(() => {
        dispatch(getPartRequestMessages(filterDto));
    }, [dispatch, partOfferId]);

    useEffect(() => {
        if (messageContainerRef.current) {
            messageContainerRef.current.scrollTop =
                messageContainerRef.current.scrollHeight;
        }
        setLoaded(true);
    }, [fetchedMessages]);


    const partRequestMessagesLoaded = useSelector(
        (state) => state.messages.partRequestMessagesLoaded
    );

    useEffect(() => {
        if (!partRequestMessagesLoaded) {
            dispatch(getPartRequestMessages({ partOfferId }));
        }
    }, [partRequestMessagesLoaded, dispatch, partOfferId]);

    useEffect(() => {
        if (fetchedMessages.length === 0) {
            setShowInfoBox(true);
        } else {
            setShowInfoBox(false);
        }
    }, [fetchedMessages]);

    const reversedMessagesForDisplay = [...fetchedMessages].reverse();

    const checkIfLoggedUserIsAuthor = (authorId) => {
        const loggedUserId = getUserObject()?.userid;
        return loggedUserId === authorId;
    };


    const GetLeftMessageBubble = (message) => (
        <div key={message.ulid} style={styles.messageBubbleRight}>
            <p style={styles.rightMessageText}>{message.body}</p>
            <p style={styles.createdAtRightText}>{getCreatedAtString(message.createdAt)}</p>
        </div>
    );

    const GetRightMessageBubble = (message) => (
        <div key={message.ulid} style={styles.messageBubbleLeft}>
            <p style={styles.leftMessageText}>{message.body}</p>
            <p style={styles.createdAtLeftText}>{getCreatedAtString(message.createdAt)}</p>
        </div>
    );

    if (!loaded) {
        return null;
    }

    return (
        <div style={styles.sidebar}>

            <div style={styles.contentWrapper}>
                <div style={styles.chatTitle}>
                    <strong>Poruke</strong>
                </div>
                {showInfoBox && (
                    <div style={styles.infoBox}>
                        <p style={styles.infoTitle}>Čestitamo na realizovanoj ponudi.</p>
                        <p style={styles.infoText}>
                            Ovde možeš da direktno komuniciraš sa kupcem, dogovorite isporuku,
                            preuzimanje, dodatne informacije oko delova i slično.
                        </p>
                        <p style={styles.createdAtComponent}>
                            <p style={styles.createdAtLeftText}>{getCreatedAtString(partOfferCreatedAt)}</p>
                        </p>

                    </div>
                )}


                <div
                    style={styles.messageContainer}
                    className="hide-scrollbar"
                    ref={messageContainerRef}
                >
                    {reversedMessagesForDisplay.map((message) =>
                        checkIfLoggedUserIsAuthor(message.author_user_id)
                            ? GetLeftMessageBubble(message)
                            : GetRightMessageBubble(message)
                    )}
                </div>
            </div>

            <div style={styles.inputWrapper}>
                <SendMessageForm
                    partOfferStatus={partOfferStatus}
                    partOfferId={partOfferId}
                    conversationUserIds={conversationUserIds}
                    onMessageSent={async () => {
                        await dispatch(getPartRequestMessages({ partOfferId }));
                    }}
                />

            </div>
        </div>
    );
};

export default ChatSidebar;

const styles = {
    sidebar: {
        position: "fixed",
        top: 0,
        right: 0,
        height: "100vh",
        width: "400px",
        backgroundColor: "#F5F5F4",
        boxShadow: "-4px 0 12px rgba(0, 0, 0, 0.2)",
        zIndex: 1000,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: 16,
    },
    closeButton: {
        position: "absolute",
        top: 8,
        right: 8,
        background: "transparent",
        border: "none",
        fontSize: 20,
        cursor: "pointer",
        color: "rgba(0, 0, 0, 0.23)",
    },
    contentWrapper: {
        display: "flex",
        flexDirection: "column",
        gap: 12,
        marginTop: 40,
        flexGrow: 1,
        overflow: "hidden",
    },
    chatTitle: {
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: "24px",
        fontWeight: 600,
    },
    wrapper: {
        padding: 20,
        border: "2px solid #693EFF",
        borderRadius: 12,
        backgroundColor: "#F5F5F4",
        display: "flex",
        flexDirection: "column",
        gap: 16,
    },
    textBox: {
        display: "flex",
        flexDirection: "column",
        gap: 30,
        width: "334px",
        height: "150px",
    },
    title: {
        fontSize: 16,
        fontWeight: 700,
        color: "rgba(0, 0, 0, 0.87)",
    },
    description: {
        fontSize: 16,
        fontWeight: 400,
        color: "rgba(0, 0, 0, 0.87)",
        lineHeight: "24px",
    },
    messageContainer: {
        flex: 1,
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        gap: 10,
        paddingRight: 5,
        paddingBottom: 10,
        marginTop: 20,
    },
    inputWrapper: {
        marginTop: 12,
    },
    messageBubbleLeft: {
        backgroundColor: "rgb(243, 244, 246)",
        border: "1px solid rgb(203, 213, 225)",
        padding: 8,
        borderRadius: 8,
        maxWidth: "70%",
        alignSelf: "flex-start",
    },
    leftMessageText: {
        fontWeight: 400,
        fontSize: 16,
        color: "rgba(0, 0, 0, 0.87)",
        textAlign: "left",
        overflowWrap: "break-word",
        wordBreak: "break-word",
    },
    createdAtLeftText: {
        fontWeight: 400,
        fontSize: 12,
        color: "rgba(0, 0, 0, 0.7)",
    },
    createdAtComponent: {
        fontSize: 14,
        color: "rgba(0, 0, 0, 0.6)",
        marginTop: 20,
        marginLeft: 10
    },
    messageBubbleRight: {
        backgroundColor: "rgb(25, 118, 210)",
        border: "1px solid rgb(25, 118, 210)",
        padding: 8,
        borderRadius: 8,
        maxWidth: "70%",
        alignSelf: "flex-end",
    },
    rightMessageText: {
        fontWeight: 400,
        fontSize: 16,
        color: "rgba(255, 255, 255, 1)",
        textAlign: "left",
        overflowWrap: "break-word",
        wordBreak: "break-word",
    },
    createdAtRightText: {
        fontWeight: 400,
        fontSize: 12,
        color: "rgba(255, 255, 255, 0.7)",
        marginTop: 10
    },
    infoBox: {
        width: 334,
        height: 179,
        border: "1px solid rgba(203, 213, 225, 1)",
        borderRadius: 8,
        backgroundColor: " rgba(243, 244, 246, 1)",
        position: "relative",

    },

    infoCloseButton: {
        position: "absolute",
        right: 10,
        background: "transparent",
        border: "none",
        fontSize: 18,
        color: "rgba(0, 0, 0, 0.4)",
        cursor: "pointer",
        marginTop: 10
    },

    infoText: {

        color: "rgba(0, 0, 0, 0.87)",
        fontSize: "16px",
        fontWeight: 400,
        marginLeft: 10
    },
    infoTitle: {
        marginTop: 20,
        marginLeft: 10,
        marginBottom: 10,
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: "16px",
        fontWeight: 400,
    }

};
